"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var CorrectCardsStatusWrapper = function CorrectCardsStatusWrapper(Component) {
  var _class, _class2, _Class;
  return (0, _mobxReact.observer)(_class = (_class2 = (_Class = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      _classCallCheck(this, _class2);
      return _callSuper(this, _class2, arguments);
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "isCurrent",
      value: function isCurrent(item) {
        return _state.DeckUI.currentCard && item.cardId === _state.DeckUI.currentCard.id;
      }
    }, {
      key: "background",
      value: function background(item) {
        if (!this.props.showBackground) {
          return;
        }
        if (this.isCurrent(item)) {
          return '#FFF';
        } else if (!item.correct && item.seen) {
          return this.props.incorrectColor;
        } else if (item.correct) {
          return this.props.correctColor;
        }
      }
    }, {
      key: "checkColor",
      value: function checkColor(item) {
        if (item.seen && (this.background(item) === this.props.incorrectColor || this.background(item) === this.props.correctColor)) {
          return '#FFF';
        } else if ((item.correct || item.currentCorrect) && this.props.showCorrectColor) {
          return this.props.correctColor;
        } else if (this.props.showIncorrectColor && (item.currentIncorrect || !item.correct)) {
          return this.props.incorrectColor;
        } else {
          return this.props.defaultColor;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          isCurrent: this.isCurrent,
          background: this.background,
          checkColor: this.checkColor,
          defaultColor: this.props.defaultColor
        }));
      }
    }]);
  }(_react["default"].Component), _Class.defaultProps = {
    defaultColor: '#333',
    incorrectColor: _constants.Theme.red,
    correctColor: _constants.Theme.green
  }, _Class), _applyDecoratedDescriptor(_class2.prototype, "isCurrent", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "isCurrent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "background", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "background"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "checkColor", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "checkColor"), _class2.prototype), _class2)) || _class;
};
CorrectCardsStatusWrapper.displayName = 'CorrectCardsStatusWrapper';
var _default = exports["default"] = CorrectCardsStatusWrapper;